import React from 'react';

const Tag = ({ tag, cl }) => {
  return <div className={cl('tag')}>{tag}</div>;
};

export default Tag;
